import { type Ref, ref } from "vue";

/**
 * Composable for inserting voice-recognized text into a plain text ref.
 * Tracks the insertion position and length so interim results
 * can be replaced in-place until recording finishes.
 *
 * Not suitable for rich-text editors (e.g. Quill) that need
 * their own insert/delete API — use this only with plain string refs.
 */
export const useVoiceTextInput = (text: Ref<string>) => {
  const voiceTextStart = ref<number | null>(null);
  const voiceTextLength = ref(0);

  const updateText = (voiceText: string) => {
    if (voiceTextStart.value === null) {
      voiceTextStart.value = text.value.length;
    }

    const before = text.value.slice(0, voiceTextStart.value);
    const after = text.value.slice(
      voiceTextStart.value + voiceTextLength.value
    );
    text.value = before + voiceText + after;
    voiceTextLength.value = voiceText.length;
  };

  const resetState = () => {
    const length = voiceTextLength.value;
    voiceTextStart.value = null;
    voiceTextLength.value = 0;
    return length;
  };

  return {
    voiceTextStart,
    voiceTextLength,
    updateText,
    resetState,
  };
};
